export default "__VITE_ASSET__DtesoXD___"